import { render, staticRenderFns } from "./CampaignCodes.vue?vue&type=template&id=4b1c995a&scoped=true&"
import script from "./CampaignCodes.vue?vue&type=script&lang=js&"
export * from "./CampaignCodes.vue?vue&type=script&lang=js&"
import style0 from "./CampaignCodes.vue?vue&type=style&index=0&id=4b1c995a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c995a",
  null
  
)

export default component.exports